import {checkSpace} from './harald-form-step1';
import {changeIndex} from './harald-form-common';

$(document).on('ready', function() {
  // fetchReserVationSettings();
  if($('#city').length) {
    fetchReserVationSettings();
  }
});

$('#city').on('change', () => {
  fetchReserVationSettings();
});

const fetchReserVationSettings = () => {
  const r_merchant  = $('#city').val();
  $('#step-1').addClass('loading');
  $('#step-edit-date').addClass('loading');
  $.ajax({
    // eslint-disable-next-line
    url: wpAjax.ajaxUrl,
    data: { action: 'get_reservation_settings', r_merchant},
    type: 'post',
    success: function(res) {
      $('#max-capacity').val(res.capacities[res.capacities.length - 1]);
      checkSpace();
    },
    error: function(err) {
      console.warn(err);
    },
    complete: function() {
      $('#step-1').removeClass('loading');
      $('#step-edit-date').removeClass('loading');
    },
  });
};


$('#reservation_date').on('change', () => {
  if($('#reservation_date').val()) {
    handleDateFetch();
    $('#reservation_time').val(null);
    checkSpace();
  }else {
    // $('.time-container ').addClass('disabled');
  }
});

$('#customer_count').on('change', () => {
  if($('#reservation_date').val()) {
  handleDateFetch();
  
  }else {
    // $('.time-container ').addClass('disabled');
  }
});

$('#form-contact-info-container').on('submit', (e) => {
  e.preventDefault();

  createReservation();
});

export const handleDateFetch = () => {
    const c_count = $('#customer_count').val();
    const r_date = $('#reservation_date').val();
    const r_merchant  = $('#city').val();
    const c_max = $('#max-capacity').val();
    $('#submit-location-and-time-form').addClass('disabled');

    if(parseInt(c_max) >= parseInt(c_count)) {
      $('#step-1').addClass('loading');
      $('#step-edit-date').addClass('loading');
      $.ajax({
        // eslint-disable-next-line
        url: wpAjax.ajaxUrl,
        data: { action: 'get_available_times', r_merchant, c_count, r_date},
        type: 'post',
        success: function(res) {
          handleQuandooFreeTimeFetchResponse(res);
          $('.time-container ').removeClass('disabled');
          console.log('handlequandoofreetimefetchresponse success');
        },
        error: function(err) {
          console.warn(err);
          $('.time-container ').addClass('disabled');
          $('#submit-location-and-time-form').addClass('disabled');
          alert('Ongelma vapaiden aikojen haussa. Päivitä sivu ja kokeile uudelleen.');
        },
        complete: function() {
          $('#step-1').removeClass('loading');
          $('#step-edit-date').removeClass('loading');
        },
      });
    } else {
      $('#reservation_time').addClass('hidden');
      $('.time-confirmation').addClass('hidden');
      $('#submit-location-and-time-form').removeClass('disabled');
    }
};


const handleQuandooFreeTimeFetchResponse = (res) => {
  $('#reservation_time').find('option').remove();
  if(res.timeSlots.length === 0) {
    $('#reservation_time').addClass('hidden');
    $('.time-confirmation').removeClass('hidden');
  }else {
    $('#reservation_time').removeClass('hidden');
    $('.time-confirmation').addClass('hidden');
    let chooseTimeText = $('#string-select-time').data('text');
    $('#reservation_time').append('<option value="">' + chooseTimeText + '</option>');
    res.timeSlots.forEach(time => {
      if(time.occupancy < 90){
        const d = new Date(time.dateTime);
        $('#reservation_time').append(`<option value="${time.dateTime}">${d.toTimeString().split(' ')[0].substring(0,5)}</option>`)
      }
    });
  }
};


export const createReservation = () => {
  $('#step-6').addClass('loading');
  const c_count = $('#customer_count').val();
  const r_date = $('#reservation_time').val();
  const r_merchant  = $('#city').val();
  const r_extra_info = $('#note').val();
  const firstName = $('#firstname').val();
  const lastName = $('#lastname').val();
  const email = $('#email').val();
  const phone = $('#phone').val();

  $.ajax({
    // eslint-disable-next-line
    url: wpAjax.ajaxUrl,
    data: {
      action: 'create_reservation',
      c_count,
      r_date,
      r_merchant,
      r_extra_info,
      firstName,
      lastName,
      email,
      phone,
    },
    type: 'post',
    success: function(res) {
      if(res.errorType){
        createOrder(false);
      }else {
        createOrder(true, res.reservation.id);
      }
    },
    error: function(err) {
      console.log('error', err)
      createOrder(false);
    },
    complete: function() {
      $('#step-6').removeClass('loading');
    },
  });
};


const createOrder = (isSavedQuandoo, id) => {
  $('#step-6').addClass('loading');

  var menuNotes = $('.menu-notes').map(function() {
    if(this.value){
      return this.value;
    }
  }).get().join('\n');

  var data = {
    firstname: $('#firstname').val(),
    lastname: $('#lastname').val(),
    phone: $('#phone').val(),
    email: $('#email').val(),
    city: $('#city option:selected').text(),
    merchant: $('#city').val(),
    customerCount: $('#customer_count').val(),
    date: $('#reservation_date').val(),
    time: $('#reservation_time').val(),
    note: $('#note').val(),
    paymentMethod: $('.payment-container input[type=radio]:checked').val(),
    billEmail: $('#bill-email').val(),
    eInvoiceAddress: $('#e-invoice-address').val(),
    businessId: $('#business-id').val(),
    operatorCode: $('#operator-code').val(),
    operator: $('#operator').val(),
    companyName: $('#company-name').val(),
    billAddress: $('#bill-address').val(),
    menuNotes: menuNotes,
    customerTimeWish: $('#enquiry-message').val(),
  };

  $.ajax({
    // eslint-disable-next-line
    url: wpAjax.ajaxUrl,
    data: {
      action: 'harald_create_order',
      products: getItems(),
      info: data,
      notify: isSavedQuandoo,
      reservation_id: id,
    },
    type: 'post',
    success: function() {
      if(!isSavedQuandoo){
        $('.confirm-reservation').removeClass('hidden');
      }
      changeIndex(7, isSavedQuandoo);
    },
    error: function(err) {
      alert('Tilauksen luonti epäonnistui, yritä uudelleen');
      console.warn(err);
    },
    complete: function() {
      $('#step-6').removeClass('loading');
    },
  })
};

const getItems = () => {
  const products = JSON.parse(window.localStorage.getItem('harald_products'));
  let items = [];
  products.forEach(product => {
    if(product.value > 0) {
      items.push({id: product.name, quantity: product.value});
    }
  });
  return items;
};





// WEBPACK FOOTER //
// ./scripts/util/quandoo.js